import React, { useEffect } from "react";
import "./App.css";
import TutorialDialog from "./Components/TutorialDialog";
import AppFooter from "./Components/AppFooter";

const Help = ({ onBack, onPrivacyPolicy, onTermsOfService }) => {
    useEffect(() => {
        const { body, documentElement } = document;
        const previousBodyOverflow = body.style.overflow;
        const previousBodyTouchAction = body.style.touchAction;
        const previousHtmlOverflow = documentElement.style.overflow;

        // Keep page scrollable on Help; only block sideways rubber-banding.
        body.style.overflow = "";
        body.style.touchAction = "pan-y";
        documentElement.style.overflow = "";

        return () => {
            body.style.overflow = previousBodyOverflow;
            body.style.touchAction = previousBodyTouchAction;
            documentElement.style.overflow = previousHtmlOverflow;
        };
    }, []);

    return (
        <div className="helpScreen">
            <div className="helpScreen__content">
                <TutorialDialog
                    open={true}
                    variant="page"
                    tutorialType="menu"
                    onClose={onBack}
                    onComplete={onBack}
                />
            </div>
            <AppFooter
                variant="overlay"
                onPrivacyPolicy={onPrivacyPolicy}
                onTermsOfService={onTermsOfService}
            />
        </div>
    );
};

export default Help;
